import { render } from "./OrgPrivacy.vue?vue&type=template&id=4925e7f6&scoped=true"
import script from "./OrgPrivacy.vue?vue&type=script&lang=js"
export * from "./OrgPrivacy.vue?vue&type=script&lang=js"

import "./OrgPrivacy.vue?vue&type=style&index=0&id=4925e7f6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4925e7f6"]])

export default __exports__